import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  fetchContentTemplateDetails,
  selectTemplateContents,
} from 'redux/content/content.slice';

import useChannelDetails from './useChannelDetails';

function useFetchContentsTemplate() {
  const location = useLocation();
  const { channel } = useChannelDetails();
  const dispatch = useDispatch();
  const content = useSelector(selectTemplateContents);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const productQuery = searchParams.get('product');
    const bucketQuery = searchParams.get('bucket');
    const nameQuery = searchParams.get('name');

    if (!productQuery || !bucketQuery || !nameQuery) return;
    dispatch(
      fetchContentTemplateDetails({
        channel: channel || '',
        reqPayload: {
          product: productQuery || '',
          bucket: bucketQuery || '',
          name: nameQuery || '',
        },
      })
    );
  }, []);

  return { content };
}

export default useFetchContentsTemplate;
